import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {DataService} from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ListfacultiesService implements Resolve<any>{
z:Observable<any>;

  constructor(private dataa:DataService) { }
   resolve (route:ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>{

    return this.dataa.returnee('faculties');


  }
  }
